import { MaskedTextField } from 'ams-ui-reactkit';
import './FormList.scss'
import { get } from 'lodash';
import { debounce } from 'debounce';
export type FormListProps = {
    list: [FormField],
    onChange?: any,
    formData?: any
};

type FormField = {
    id: string;
    type?: string;
    inputProps?: any;
    label: string;
    onChange?: any;
    field?: any;
    value?: any
}

const FormList = ({ list, onChange,formData }: FormListProps) => {
    const changeHandler = (e:any, id:any, value:any) => {
        onChange(e, id ? id : '', value);
    }
    const debounceChangeHandler = debounce(changeHandler, 1000);

    return (
        <div className="formList">
            {list && list.length > 0 && list.map((item: any, key: number) => {
                const fileldData = get(formData, `${item.dataField}`, "");
                return <div className="singleField" key={key}><MaskedTextField
                    defaultValue={fileldData}
                    id={item.id}
                    type={item.type}
                    label={item.label}
                    error={false}
                    onChange={(e: any) => debounceChangeHandler(e, item.id ? item.id : '', e.target.value)}
                    isMask={false}
                    {...item}
                />
                </div>
            })}
        </div>
    )
}

export default FormList